import axios from 'axios';
import config from '../../config';

// import tokenApi from './tokenApi';

const userInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class UserApi {

	static UserLogin(payload) {
		return userInstance.post('/student/login', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}


// 	static UserLogout(payload) {
// 		localStorage.removeItem('')
// 		return userInstance.post('/hbouser/logout', payload)
// 		.then(function (response) {
// 			localStorage.clear();
// 			return response.data;
// 		})
// 		.catch(function (error) {
// 			throw(error);
// 		});
//   }

// 	static UserGetProfile(token, id) {
// 		return userInstance.get(`/hbouser/profile?sessionToken=${token}&channelPartnerID=${id}&multiProfileId=0`)
// 		.then(function (response) {
// 			if('channelPartnerID' in response.data && response.data.channelPartnerID !== localStorage.getItem('channel_partner_id')){
// 				localStorage.setItem('channel_partner_id', response.data.channelPartnerID);
// 			}
// 			return response.data;
// 		})
// 		.catch(function (error) {
// 			if(error.response.status === 401){
// 				localStorage.removeItem('u');
// 				localStorage.removeItem('session_token');
// 				localStorage.removeItem('channel_partner_id');
// 				window.parent.location = `${window.parent.location.origin}/`;
// 			}
// 			throw(error);
// 		});
// 	}


// 	static UserAuthenticateCustomerForOperator(token, id) {
// 		const payload = {
// 	    operatorJWT: token,
// 	    channelPartnerID: id
// 	  };
// 		return userInstance.post('/hbouser/authenticateCustomerForOperator', payload)
// 		.then(function (response) {
// 			return response.data;
// 		})
// 		.catch(function (error) {
// 			throw(error);
// 		});
//   }
  

//   static UserUpdateProfile(payload) {
//     return userInstance.post('/hbouser/updateProfile', payload)
// 		.then(function (response) {
// 			return response.data;
// 		})
// 		.catch(function (error) {
// 			throw(error);
// 		});
//   }


	/*
	static UserInsert(payload) {
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return userInstance.post('/users', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserUpdate(payload, id) {
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return userInstance.patch(`/users/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserGetList(page, perPage, filter) {
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return userInstance.get(`/users?page=${page}&perPage=${perPage}${filter}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserDelete(id) {
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return userInstance.delete(`/users/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserRegistration(payload) {
		return userInstance.post(`/auth/register`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error.response);
		});
	}
	*/
}

export default UserApi;
